import GetFormConsultation from './GetFormConsultation'
import GetFormConsultationContact from './GetFormConsultationContact'

export default function Components(Vue) {
  Vue.component('GetFormConsultation', GetFormConsultation)
  Vue.component('GetFormConsultationContact', GetFormConsultationContact)
}



// WEBPACK FOOTER //
// ./src/js/components/app/Forms/index.js